import { branches } from '@/configs/endpoints'
import api from '@/plugins/api'
import requestValidation from '@/configs/requestValidation'
import { formData } from '@/configs/dates'
const store = 'branches'

export default {
  state: () => ({
    measuringLaboratory: null,
    branches: [],
    branchPageCount: 0,
    branch: {},
    branchAlreadyEquipmentList: [],
    branchAlreadyStatementEquipmentList: [],
    branchWorkLine: [],
    equipmentType: [],
    addressString: '',

    checkEquipmentList: null,
    letter: null,
    statement: null,
    survey: null,
    passport: null,
    accreditation: null,
    questionnaire: null,
    evaluation: null,
    documentsList: null,

    branchStatementList: [],
    branchStatementCount: 0,
    branchStatement: {},
    moderationStatementBranchQuestion: [],
    moderationStatementBranchFileQuestion: []
  }),
  mutations: {
    UPDATE_EQUIPMENT (state, data) {
      let index = state.branchAlreadyEquipmentList.findIndex(e => e.id === data.id)
      if (index !== -1) {
        state.branchAlreadyEquipmentList.splice(index, 1, data)
      }
    },
    UPDATE_EQUIPMENT_FILE (state, data) {
      let index = state.branchAlreadyEquipmentList.findIndex(e => e.id === data.id)
      if (index !== -1) {
        state.branchAlreadyEquipmentList[index].serial_number_photo = data.serial_number_photo
      }
    },
  },
  DELETE_EQUIPMENT (state, id) {
    let index = state.branchAlreadyEquipmentList.findIndex(e => e.id === id)
    if (index !== -1) {
      state.branchAlreadyEquipmentList.splice(index, 1)
    }
  },
  getters: {
    reprocessingTypeReviewBranch: state => {
      // previous_statement_step: type_review
      let typeReviewByPrevStatus = {
        1: 3,
        2: 1
      }
      if (state.branchStatement) {
        return typeReviewByPrevStatus[state.branchStatement.previous_statement_step]
      }
    },
  },
  actions: {
    async getLaboratoryInfo (context, id) {
      const response = await api.get(branches.laboratory(id))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'measuringLaboratory', data: response.data })
        return response.data
      }
      return null
    },
    async updateLaboratoryInfo (context, data) {
      const response = await api.patch(branches.laboratory(data.id), { body: data.body })
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'measuringLaboratory', data: response.data })
      }
    },

    async getBranches (context, filter) {
      const params = new URLSearchParams()
      for (let field in filter) {
        if (!filter[field]) continue
        if (Array.isArray(filter[field])) {
          filter[field].forEach(value => {
            if (value !== undefined && value !== null && value !== '') {
              params.append(field, value)
            }
          })
        } else {
          params.append(field, filter[field])
        }
      }

      const response = await api.get(`${branches.branches}?${ params }`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'branches', data: response.data.results })
        context.commit('SET_DATA', { store, state: 'branchPageCount', data: response.data.count })
      }
    },

    async getBranch (context, id) {
      const response = await api.get(`${branches.branch(id)}`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'branch', data: response.data })
        return response.data
      }
      return null
    },

    async changeBranchCertificationAgency (context, data) {
      const response = await api.patch(branches.changeCertificationAgency(data.id), {
        body: { certification_agency: data.certificationAgency }
      })
      if (await requestValidation(response)) {
        context.commit('SET_DATA', {
          store,
          state: 'branch',
          data: {
            ...context.state.branch,
            certification_agency: data.certificationAgency
          }
        })
        return true
      }
      return false
    },

    async getBranchWorkLine (context, id) {
      const response = await api.get(`${branches.workLine(id)}`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'branchWorkLine', data: response.data })
        return response.data
      }
      return []
    },

    setAddress (context, data) {
      context.commit('SET_DATA', { store, state: 'addressString', data: data })
    },

    async getEquipmentType (context) {
      const response = await api.get(branches.equipmentType)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'equipmentType', data: response.data })
        return response.data
      }
      return false
    },


    async getBranchStatementEquipment (context, ids) {
      const response = await api.get(`${branches.statementBranchEquipment(ids)}`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'branchAlreadyEquipmentList', data: response.data })
      }
    },
    async createBranchStatementEquipmentItem (context, data) {
      const response = await api.post(branches.statementBranchEquipment(data.ids), { body: data.body })
      if (await requestValidation(response)) {
        context.commit('ADD_DATA', { store, state: 'branchAlreadyEquipmentList', data: response.data })
        return response.data
      }
    },
    async updateBranchStatementEquipmentItem (context, data) {
      const response = await api.patch(branches.updateStatementBranchEquipment(data.ids), { body: data.body })
      if (await requestValidation(response)) {
        context.commit('UPDATE_EQUIPMENT', response.data)
      }
    },

    async deleteBranchStatementEquipmentItem (context, data) {
      const response = await api.delete(branches.deleteWorkLine(data.ids))
      if (await requestValidation(response)) {
        context.commit('DELETE_EQUIPMENT', data.ids.id)
      }
    },
    async updateBranchStatementEquipmentMedia (context, data) {
      const body = new FormData()
      body.append('serial_number_photo', data.file)

      const endpoint = data.isStatementEndpoint
        ? branches.updateStatementBranchEquipmentMedia(data.ids)
        : branches.updateBranchEquipmentMedia(data.ids)

      const requestMethod = data.isStatementEndpoint
        ? api.post.bind(api)
        : api.patch.bind(api)
      const response = await requestMethod(endpoint, { body: body })
      if (await requestValidation(response)) {
        context.commit('UPDATE_EQUIPMENT_FILE', {
          id: data.ids.id,
          serial_number_photo: response.data.serial_number_photo
        })
      }
    },
    async getBranchStatementWorkLine (context, id) {
      const response = await api.get(`${branches.statementWorkLine(id)}`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'branchWorkLine', data: response.data })
        return response.data
      }
      return []
    },
    async getBranchWorkLineCombined (context, id) {
      const [statementResult, commonResult] = await Promise.allSettled([
        api.get(`${branches.statementWorkLine(id)}`),
        api.get(`${branches.workLine(id)}`)
      ])

      const uniqueById = new Map()

      const collectData = async (result, isStatement) => {
        if (result?.status === 'fulfilled') {
          const response = result.value
          if (await requestValidation(response)) {
            response.data.forEach(item => {
              uniqueById.set(item.id, {
                ...item,
                isStatement
              })
            })
          }
        }
      }

      await collectData(statementResult, true)
      await collectData(commonResult, false)

      context.commit('SET_DATA', {
        store,
        state: 'branchWorkLine',
        data: Array.from(uniqueById.values())
      })
    },
    async updateBranchStatementWorkLine (context, data) {
      const response = await api.patch(branches.updateStatementWorkLine(data.ids), { body: data.body } )
      if (await requestValidation(response)) {
        context.commit('UPDATE_DATA', { store, state: 'branchWorkLine', data: response.data })
      }
    },


    async getBranchEquipment (context, ids) {
      const response = await api.get(`${branches.branchEquipment(ids)}`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'branchAlreadyEquipmentList', data: response.data })
      }
    },
    async updateBranchEquipmentItem (context, data) {
      const response = await api.patch(branches.updateBranchEquipment(data.ids), { body: data.body })
      if (await requestValidation(response)) {
        context.commit('UPDATE_EQUIPMENT', response.data)
      }
    },

    // --------------------------------------------------------------------

    async checkEquipment (context, data) {
      const response = await api.post(branches.checkEquipment, { body: data.body })
      if (requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'checkEquipmentList', data: response.data })
      }
    },
    async generateLetter (context, data) {
      const response = await api.post(branches.generateLetter, { body: data.body })
      if (requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'letter', data: response.data })
      }
    },
    async generateStatement (context, data) {
      const response = await api.post(branches.generateStatement, { body: data.body })
      if (requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'statement', data: response.data })
      }
    },
    async generateSurvey (context, data) {
      const response = await api.post(branches.generateSurvey, { body: data.body })
      if (requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'survey', data: response.data })
      }
    },
    async generatePassport (context, data) {
      const response = await api.post(branches.generatePassport, { body: data.body })
      if (requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'passport', data: response.data })
      }
    },
    async generateAccreditation (context, data) {
      const response = await api.post(branches.generateAccreditation, { body: data.body })
      if (requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'accreditation', data: response.data })
      }
    },
    async generateQuestionnaire (context, data) {
      const response = await api.post(branches.generateQuestionnaire, { body: data.body })
      if (requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'questionnaire', data: response.data })
      }
    },
    async generateEvaluation (context, data) {
      const response = await api.post(branches.generateEvaluation, { body: data.body })
      if (requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'evaluation', data: response.data })
      }
    },
    async generateDocumentsList (context, data) {
      const response = await api.post(branches.generateDocumentsList, { body: data.body })
      if (requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'documentsList', data: response.data })
      }
    },

    // Statement branch for existing laboratory
    async getBranchStatementList (context, filter) {
      const params = new URLSearchParams()
      for (let field in filter) {
        if (!filter[field]) continue
        if (Array.isArray(filter[field])) {
          filter[field].forEach(value => {
            if (value !== undefined && value !== null && value !== '') {
              params.append(field, value)
            }
          })
        } else {
          params.append(field, filter[field])
        }
      }
      const response = await api.get(`${branches.statementBranch()}?${ params }`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'branchStatementList', data: response.data.results })
        context.commit('SET_DATA', { store, state: 'branchStatementCount', data: response.data.count })
      }
    },
    async getBranchStatement (context, id) {
      const response = await api.get(branches.statementBranch(id))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'branchStatement', data: response.data })
      }
    },
    async createBranchStatement (context, body) {
      const response = await api.post(branches.statementBranch(), { body: body })
      if (await requestValidation(response)) {
        context.commit('ADD_DATA', { store, state: 'branchStatementList', data: response.data })
        context.commit('SET_DATA', { store, state: 'branchStatement', data: response.data })
      }
    },
    async updateBranchStatement (context, data) {
      const response = await api.patch(branches.updateStatementBranch(data.ids), { body: data.body })
      if (await requestValidation(response)) {
        context.commit('ADD_DATA', { store, state: 'branchStatementList', data: response.data })
        context.commit('SET_DATA', { store, state: 'branchStatement', data: response.data })
      }
    },
    async updateLaboratoryBranch (context, data) {
      const response = await api.post(branches.updateLaboratoryBranchStatement(data.ids), { body: data.body })
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'branch', data: response.data })
      }
      return response
    },
    async uploadMediaBranchStatement (context, data) {
      return Promise.all(data.items.map(async item => {
        return await api.post(branches.statementBranchMediaUpload(data.id), { body: formData(item) })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    updateMediaBranchStatement (context, data) {
      return Promise.all(data.items.map(async item => {
        return await api.put(branches.statementBranchMediaUpdate(data.ids), { body: formData(item) })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    updateMediaLaboratoryBranch (context, data) {
      return Promise.all(data.items.map(async item => {
        return await api.put(branches.statementBranchMediaUpdate(data.ids.branchId), { body: formData(item) })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    async deleteMediaBranchStatement (context, data) {
      const response = await api.delete(branches.statementBranchMediaRemove(data))
      return !!(await requestValidation(response))
    },

    async getStatementBranchQuestion (context, data) {
      let typeReview = context.getters.reprocessingTypeReviewBranch
      const response = await api.get(`${branches.reprocessingStatementBranch({ id: data.id, branchId: data.branchId })}?answer=2&type_review=${typeReview}`)
      if (response.data.length && await requestValidation(response)) {
        let branchQuestion = response.data.map(e => {
          return { field_name: e.check_list_question.field_name, comment: e.comment }
        })
        context.commit('SET_DATA', { store, state: 'moderationStatementBranchQuestion', data: branchQuestion })
      }
    },

    async getStatementBranchFileQuestion (context, data) {
      let typeReview = context.getters.reprocessingTypeReviewBranch
      const response = await api.get(`${branches.reprocessingStatementBranchFile({ id: data.id, branchId: data.branchId })}?answer=2&type_review=${typeReview}`)

      if (response.data.length && await requestValidation(response)) {
        let branchFile = response.data.map(e => ({ field_name: e.file_type, comment: e.comment }))
        context.commit('SET_DATA', { store, state: 'moderationStatementBranchFileQuestion', data: branchFile })
      }
    }
  }
}
